// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__6hjYs","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__fwrfM"};